import { defineStyleConfig } from "@chakra-ui/react";

export const textareaTheme = defineStyleConfig({
   variants: {
      outline: {
         bgColor: "white",
         borderRadius: "none",
         _focus: {
            borderColor: "brandBlue.500",
         },
      },
   },
   defaultProps: {},
});
